"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Table_1 = require("@sportnet/ui/lib/Table");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var utilities_1 = require("@sportnet/utilities");
var ContentContext_1 = tslib_1.__importDefault(require("../../../common/ContentContext"));
var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));
var Header_1 = tslib_1.__importDefault(require("../../../view/components/Header"));
var utilities_2 = require("../../../utilities/utilities");
var utilities_3 = require("../MatchesList/utilities");
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  th {\n    vertical-align: bottom;\n  }\n"], ["\n  th {\n    vertical-align: bottom;\n  }\n"])));
var TeamName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.fadedText;
}, polished_1.rem(12));
var StyledTd = styled_components_1["default"](Table_1.Td)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), polished_1.rem(120));
var Title = styled_components_1["default"](Header_1["default"])(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  && {\n    > h2 {\n      font-size: ", ";\n      font-weight: bold;\n    }\n  }\n"], ["\n  && {\n    > h2 {\n      font-size: ", ";\n      font-weight: bold;\n    }\n  }\n"])), polished_1.rem(18));
var CompetitionStanding = function (_a) {
    var _b;
    var data = _a.data, renderEmpty = _a.renderEmpty;
    var context = React.useContext(ContentContext_1["default"]);
    if ((!data.competitionId || !data.partId) && renderEmpty) {
        return React.createElement(React.Fragment, null, renderEmpty('competitionStanding'));
    }
    if (data.data) {
        var _c = data.data, results = _c.results, teamResults = _c.teamResults, codelist_1 = _c.codelist;
        var formatPoints_1 = function (value, format, diff) {
            if (diff === void 0) { diff = false; }
            if (!format) {
                return value;
            }
            switch (format) {
                case 'time':
                    if (diff) {
                        return "+ " + utilities_2.formatSecondsToString(value);
                    }
                    return "" + utilities_2.formatSecondsToString(value);
                default:
                    return value;
            }
        };
        var filterResults = function (item) {
            var point = (item.totalPoints || []).find(function (i) { var _a; return i && i.name === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); });
            if ((point && point.value) || !data.omitEmpty) {
                return item;
            }
            return null;
        };
        var sortResults = function (a, b) {
            var aPoint = (a.totalPoints || []).find(function (i) { var _a; return i && i.name === ((_a = data.sortingPoint) === null || _a === void 0 ? void 0 : _a._id); });
            var bPoint = (b.totalPoints || []).find(function (i) { var _a; return i && i.name === ((_a = data.sortingPoint) === null || _a === void 0 ? void 0 : _a._id); });
            if (!aPoint || !aPoint.value) {
                return 1;
            }
            else if (!bPoint || !bPoint.value) {
                return -1;
            }
            else if (aPoint &&
                bPoint &&
                Number(aPoint.value) > Number(bPoint.value)) {
                return data.sort === 'asc' ? 1 : -1;
            }
            else if (aPoint &&
                bPoint &&
                Number(aPoint.value) < Number(bPoint.value)) {
                return data.sort === 'asc' ? -1 : 1;
            }
            return 0;
        };
        var getTeamNameFunc_1 = utilities_1.getProp(context, ['helpers', 'getTeamName'], utilities_3.getTeamName);
        var slicedResults_1 = results
            .filter(filterResults)
            .sort(sortResults)
            .slice(0, data.limit || results.length);
        var slicedTeamResults_1 = teamResults
            .filter(filterResults)
            .sort(sortResults)
            .splice(0, data.limit || teamResults.length);
        return (React.createElement(Wrapper, { className: "content-widget-competitionStanding-wrapper" },
            data.title && React.createElement(Title, null, data.title),
            React.createElement(Table_1.Table, null,
                React.createElement(Table_1.Thead, null,
                    React.createElement(Table_1.Tr, null,
                        React.createElement(Table_1.Th, null, "#"),
                        data.displayType !== 'team_total' && (React.createElement(Table_1.Th, null, utilities_2.__('Meno a priezvisko'))),
                        React.createElement(Table_1.Th, null, utilities_2.__('Tím')),
                        React.createElement(Table_1.Th, { width: 100 }, (_b = data.point) === null || _b === void 0 ? void 0 : _b.label),
                        React.createElement(Table_1.Th, { width: 100 }, utilities_2.__('Rozdiel')))),
                React.createElement(Table_1.Tbody, null,
                    data.displayType === 'individual' && (React.createElement(React.Fragment, null, slicedResults_1.map(function (result, idx) {
                        var pointObj = (result.totalPoints || []).find(function (i) { var _a; return i && i.name === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); });
                        var sortingPointObj = (result.totalPoints || []).find(function (i) { var _a; return i && i.name === ((_a = data.sortingPoint) === null || _a === void 0 ? void 0 : _a._id); });
                        var diffPointObj = idx
                            ? slicedResults_1[0].totalPoints.find(function (i) { var _a; return i && i.name === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); })
                            : undefined;
                        var codelistItem = codelist_1.find(function (c) { var _a; return c._id === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); });
                        return (React.createElement(Table_1.Tr, { key: "tr_" + result.players
                                .map(function (p) { return p._id; })
                                .join(',') },
                            React.createElement(Table_1.Td, null, sortingPointObj === null || sortingPointObj === void 0 ? void 0 : sortingPointObj.value),
                            React.createElement(Table_1.Td, null, result.players.map(function (p) { return p.name; }).join(', ')),
                            React.createElement(Table_1.Td, null,
                                ' ',
                                React.createElement(TeamName, null, result.team.detailUrl ? (React.createElement("a", { href: result.team.detailUrl }, getTeamNameFunc_1(data.appSpace, result.team))) : (getTeamNameFunc_1(data.appSpace, result.team)))),
                            React.createElement(StyledTd, null, pointObj &&
                                formatPoints_1(pointObj.value, codelistItem === null || codelistItem === void 0 ? void 0 : codelistItem.format)),
                            React.createElement(StyledTd, null, pointObj &&
                                diffPointObj &&
                                formatPoints_1(pointObj.value - diffPointObj.value, codelistItem === null || codelistItem === void 0 ? void 0 : codelistItem.format, true))));
                    }))),
                    data.displayType === 'individual_total' && (React.createElement(React.Fragment, null, slicedResults_1.map(function (result, idx) {
                        var pointObj = (result.totalPoints || []).find(function (i) { var _a; return i.name === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); });
                        var sortingPointObj = (result.totalPoints || []).find(function (i) { var _a; return i && i.name === ((_a = data.sortingPoint) === null || _a === void 0 ? void 0 : _a._id); });
                        var diffPointObj = idx
                            ? slicedResults_1[0].totalPoints.find(function (i) { var _a; return i && i.name === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); })
                            : undefined;
                        var codelistItem = codelist_1.find(function (c) { var _a; return c._id === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); });
                        return (React.createElement(Table_1.Tr, { key: "tr_" + result.players
                                .map(function (p) { return p._id; })
                                .join(',') },
                            React.createElement(Table_1.Td, null, sortingPointObj === null || sortingPointObj === void 0 ? void 0 : sortingPointObj.value),
                            React.createElement(Table_1.Td, null, result.players.map(function (p) { return p.name; }).join(', ')),
                            React.createElement(Table_1.Td, null,
                                React.createElement(TeamName, null, result.team.detailUrl ? (React.createElement("a", { href: result.team.detailUrl }, getTeamNameFunc_1(data.appSpace, result.team))) : (getTeamNameFunc_1(data.appSpace, result.team)))),
                            React.createElement(StyledTd, null, pointObj &&
                                formatPoints_1(pointObj.value, codelistItem === null || codelistItem === void 0 ? void 0 : codelistItem.format)),
                            React.createElement(StyledTd, null, pointObj &&
                                diffPointObj &&
                                formatPoints_1(pointObj.value - diffPointObj.value, codelistItem === null || codelistItem === void 0 ? void 0 : codelistItem.format, true))));
                    }))),
                    data.displayType === 'team_total' && (React.createElement(React.Fragment, null, slicedTeamResults_1.map(function (result, idx) {
                        var pointObj = (result.totalPoints || []).find(function (i) { var _a; return i.name === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); });
                        var sortingPointObj = (result.totalPoints || []).find(function (i) { var _a; return i && i.name === ((_a = data.sortingPoint) === null || _a === void 0 ? void 0 : _a._id); });
                        var diffPointObj = idx
                            ? slicedTeamResults_1[0].totalPoints.find(function (i) { var _a; return i && i.name === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); })
                            : undefined;
                        var codelistItem = codelist_1.find(function (c) { var _a; return c._id === ((_a = data.point) === null || _a === void 0 ? void 0 : _a._id); });
                        return (React.createElement(Table_1.Tr, { key: "tr_" + result.team._id },
                            React.createElement(Table_1.Td, null, sortingPointObj === null || sortingPointObj === void 0 ? void 0 : sortingPointObj.value),
                            React.createElement(Table_1.Td, null, result.team.detailUrl ? (React.createElement("a", { href: result.team.detailUrl }, getTeamNameFunc_1(data.appSpace, result.team))) : (getTeamNameFunc_1(data.appSpace, result.team))),
                            React.createElement(StyledTd, null, pointObj &&
                                formatPoints_1(pointObj.value, codelistItem === null || codelistItem === void 0 ? void 0 : codelistItem.format)),
                            React.createElement(StyledTd, null, pointObj &&
                                diffPointObj &&
                                formatPoints_1(pointObj.value - idx - diffPointObj.value, codelistItem === null || codelistItem === void 0 ? void 0 : codelistItem.format, true))));
                    })))))));
    }
    return null;
};
exports["default"] = CompetitionStanding;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
